import React from 'react';
import { useNavigate } from 'react-router-dom';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { IconLibrary } from '@product-framework/index';
import { useServiceProvider } from '../../../../providers/ServiceProviderProvider';

function SPOrSPDispatchInActiveCheck({ children, onClose }) {
  const navigate = useNavigate();
  const { dispatchMethod, serviceProvider } = useServiceProvider();

  const isInActiveSP = serviceProvider?.status === 'INACTIVE';
  const isInActiveSPDispatchMethod =
    dispatchMethod?.dispatchMethod === 'INACTIVE';

  if (!isInActiveSP && !isInActiveSPDispatchMethod) {
    return children;
  }

  return (
    <Box>
      <DialogContent>
        <Typography sx={{ mb: 0 }}>
          <FormattedMessage
            id="THIS_SERVICE_PROVIDER_IS_INACTIVE_AND_CANNOT_BE_ASSIGNED_TO_A_JOB"
            defaultMessage="This Service Provider is inactive and cannot be assigned to a Job."
          />
        </Typography>
        <Typography>
          <FormattedMessage
            id="TO_PROCEED_UPDATE_THE_SERVICE_PROVIDERS_PROFILE"
            defaultMessage="To proceed, update the Service Provider's profile."
          />{' '}
        </Typography>
        <ul>
          {isInActiveSP && (
            <li>
              <Typography sx={{ fontWeight: '500' }} variant="body1">
                <FormattedMessage
                  id="SERVICE_PROVIDER_STATUS_MUST_BE_ACTIVE"
                  defaultMessage="Service Provider Status must be Active."
                />{' '}
                <Typography
                  color="error"
                  component="span"
                  sx={{ fontWeight: '500' }}
                  variant="caption">
                  (
                  <FormattedMessage
                    id="CURRENTLY"
                    defaultMessage="Currently"
                  />{' '}
                  {serviceProvider?.status})
                </Typography>
              </Typography>
            </li>
          )}
          {isInActiveSPDispatchMethod && (
            <li>
              <Typography sx={{ fontWeight: '500' }} variant="body1">
                <FormattedMessage
                  id="DISPATCH_METHOD_CANNOT_BE_INACTIVE"
                  defaultMessage="Dispatch Method cannot be Inactive."
                />{' '}
                <Typography
                  color="error"
                  component="span"
                  sx={{ fontWeight: '500' }}
                  variant="caption">
                  (
                  <FormattedMessage
                    id="CURRENTLY"
                    defaultMessage="Currently"
                  />{' '}
                  {dispatchMethod})
                </Typography>
              </Typography>
            </li>
          )}
        </ul>
      </DialogContent>
      <DialogActions display="flex" sx={{ justifyContent: 'center', my: 2 }}>
        <Button
          startIcon={<IconLibrary.ServiceProvider />}
          onClick={() => {
            navigate(`/serviceproviders/edit/${serviceProvider.id}`);
          }}
          variant="contained">
          <FormattedMessage
            id="OPEN_SERVICE_PROVIDER"
            defaultMessage="Open Service Provider"
          />
        </Button>
        <Button
          startIcon={<IconLibrary.Close />}
          variant="outlined"
          onClick={() => onClose()}>
          <FormattedMessage id="CLOSE" defaultMessage="Close" />
        </Button>
      </DialogActions>
    </Box>
  );
}

export default SPOrSPDispatchInActiveCheck;
